<div class="card" [class.wide-content]="wideContent">
  <ng-content></ng-content>
</div>
